export default {
  type: Object.freeze({
    ROOT: 'root', ADMIN: 'admin', OPERATOR: 'operator', SYS_ADMIN: 'sys_admin', SUPPORT: 'support',
    DOCTOR: 'doctor', ALL: 'all'
  }),
  category: Object.freeze({
    USUAL: 'usual', SERVICE: 'service', USUAL_LABEL: 'Роли', SERVICE_LABEL: 'Сервисные роли'
  }),
}
